import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import AppManager from "../../../managers/AppManager";
import RouteManager, { PAGE_ROUTES } from "../../../managers/RouteManager";
import DataGridHolderPayroll from "../../common/DataGridHolderPayroll";
import { COLUMN_CODE, TableManger, TABLES, TABLE_DISPLAY_NAME } from "../../../managers/TableManger";
import { INPUT_TYPE, ROW_DATA, TIMESHEET_REORT_MAIN_GRID_COLUMN, TIMESHEET_REORT_SUB_GRID_COLUMN } from "../../../constants/Constant";
import { parseColumnConfig, parseVisibleColumnConfig } from "../../configs/config";
import Utility, { deepClone, shiftArrayElement } from "../../../utility/Utility";
import AddTimesheetReport from "./AddTimesheetReport";
import { fetchBooksContact, selectBooksContact } from "../../../Redux/Slices/BooksContactSlice";
import { fetchProject, selectProject } from "../../../Redux/Slices/ProjectSlice";
import { fetchTask, selectTask } from "../../../Redux/Slices/TaskSlice";
import { fetchEmployeeListWithoutFilter, selectEmployeeListWithoutLimit } from "../../../Redux/Slices/EmployeeListSlice";
import moment from "moment";
import TimesheetService, { TIMESHEET_CONSTANTS } from "../TimesheetService";
import i18next from "i18next";
import ic_check_mark from "../../../assets/icons/check.svg";

import {
    DKIcon,
    DKIcons,
    TOAST_TYPE,
    showToast,
    showLoader,
    removeLoader,
    DKDateRangePicker,
    DKListPicker2,
    DKButton,
    DKDataGrid,
    DKLabel,
    DKSearchBar,
    DKFilterPopup,
    DKSpinner,
    showAlert
} from "deskera-ui-library";
import TimesheetUtils from "../TimesheetUtils";
import FormatCurrencyService from "../../../services/FormatCurrencyService";
import { DATE_FORMAT } from "../../../constants/Constant";
import ic_arrow_back from "../../../assets/icons/ic_arrow_back.svg";
import SideBarService from "../../../services/sidebar";
import { PipelineManager } from "../../../managers/PipelineManager";
import Table from "../../../services/table";
import PermissionUtils, { ACTION, MODULE } from "../../user-permissions/PermissionUtils";

function TimesheetReportGrouping(props) {
    const history = useHistory();
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [width, setWidth] = useState(SideBarService.getContainerWidth())
    const initialState = {
        columnData: TIMESHEET_REORT_MAIN_GRID_COLUMN,
        rowData: [],
        originalData: [],
        filter: []
    };

    const booksContact = useSelector(selectBooksContact);
    const project = useSelector(selectProject);
    const task = useSelector(selectTask);
    const employeeResponse = useSelector(selectEmployeeListWithoutLimit);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPageCount, setTotalPageCount] = useState(0);
    const [timesheetData, setTimesheetData] = useState(initialState);
    const [showAddTimesheet, setShowAddTimesheet] = useState(false);
    const [showDateRangePicker, setShowDateRangePicker] = useState(false);
    const [fromDate, setFromDate] = useState(moment().startOf("month").startOf("day"));
    const [toDate, setToDate] = useState(moment().endOf("month").endOf("day"));
    const [filterArray,setFilterArray] = useState([]);
    const [rowExpander, setRowExpander] = useState(
        {
            
        }
    );
    const [filterCustomerPopup,setFilterCustomerPopup] = useState({
        show:false,
        value:'All'
    })
    const [customer,setCustomer] = useState([])
    const [filterPopupState,setFilterPopupState] = useState(false);
    const [selectedRecords,setSelectedRecords] = useState([])
    const [approveReject,setApproveReject] = useState({
        isApproveEnable:false,
        isRejectEnable:false
    })
    const [childColumn,setChildColumn] = useState(parseVisibleColumnConfig(parseColumnConfig(TableManger.getTableVisibleColumns(TABLES.PEOPLE_TIMESHEET_REPORT_GROUP_SUB_TABLE)), TABLES.PEOPLE_TIMESHEET_REPORT_GROUP_SUB_TABLE))
    const [showSpinner, setSpinner] = useState(false);
    useEffect(() => {
        RouteManager.setPresenter({ props: { ...props, history: history } });
        AppManager.scrollToTop();
        window.addEventListener("resize", windowSizeUpdated);
      window.addEventListener('onSideBarChange', windowSizeUpdated);
        const rowData = []
        const Column = parseVisibleColumnConfig(parseColumnConfig(TIMESHEET_REORT_MAIN_GRID_COLUMN), TABLES.PEOPLE_TIMESHEET_REPORT);
        const passingData = {
            columnData: deepClone(Column),
            rowData,
            filter: '',
            originalData: rowData
        };
        setTimesheetData(passingData);
        fetchDependencies()
        getReport({
            currentPage: 1,
            limit: 20,
            fromDate: moment().startOf("month").startOf("day").format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
            toDate: moment().endOf("month").endOf("day").format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
            searchString:''
        });
        return ()=>{
            window.removeEventListener("resize", windowSizeUpdated);
            window.removeEventListener('onSideBarChange', windowSizeUpdated);
        }
    }, []);
    useEffect(()=>{
        if(childColumn) {
            setTimesheetData({
                ...timesheetData
            });
        }
    },[childColumn])
    useEffect(() => {
        if (!Utility.isEmpty(booksContact)) {
            const columns = deepClone(childColumn);
            const ind = columns.findIndex(c => c.columnCode === 'customerId')
            if (ind !== -1) {
                columns[ind].options = booksContact?.map(e => { return { ...e, label: e.name, value: e.customer, id: e.id.toString() } }) || []
                setChildColumn(columns)
                
            }

        }
    }, [booksContact]);

    useEffect(() => {
        if (!Utility.isEmpty(project)) {
            const columns = deepClone(childColumn);
            const ind = columns.findIndex(c => c.columnCode === 'projectId')
            if (ind !== -1) {
                columns[ind].options = project?.data?.map(e => { return { ...e, label: e.name, value: e.id } }) || []
                setChildColumn(columns)
                
            }
        }
    }, [project]);

    useEffect(() => {
        if (!Utility.isEmpty(task)) {
            const columns = deepClone(childColumn);
            const ind = columns.findIndex(c => c.columnCode === 'jobId')
            if (ind !== -1) {
                columns[ind].options = task?.data?.map(e => { return { ...e, label: e.name, value: e.id } }) || []
                setChildColumn(columns)
                
            }
        }
    }, [task]);

    useEffect(() => {
        if (!Utility.isEmpty(employeeResponse)) {
            const columns = deepClone(childColumn);
            const ind = columns.findIndex(c => c.columnCode === 'employeeId')
            if (ind !== -1) {
                columns[ind].options = employeeResponse?.users?.map(e => { return { ...e, label: e.name, value: e.userId } }) || []
                setChildColumn(columns)
                
            }

        }
    }, [employeeResponse]);
    const windowSizeUpdated = () => {
        setWidth(SideBarService.getContainerWidth())
    };
    const fetchDependencies = async () => {
        setSpinner(true)

        const dependencies = [
            dispatch(fetchEmployeeListWithoutFilter()),
            dispatch(fetchBooksContact()),
            dispatch(fetchTask()),
            dispatch(fetchProject()),
            TimesheetService.getCustomers(false)
        ]        
        const response = await Promise.all(dependencies);
        setSpinner(false)

        setCustomer(response[4] || [])
    }

    const getReport = (config,needToCollapseDefault=true) => {
        setSpinner(true)
        TimesheetService.GROUING_REPORTS_API_CONFIG = { ...config }
        setRowExpander({
            [0]:{
                expand:false,
                childIndex:[]
            }
        })
        updateApproveReject([])
        TimesheetService.getGroupingReportData(config).then(
            (response) => {
                setSpinner(false)
                if (Array.isArray(response?.data)) {
                    setTimesheetData({
                        ...timesheetData,
                        rowData: formatRowDate(response?.data,true,needToCollapseDefault) || []
                    })
                    setCurrentPage(parseInt(response.filterConfig.page));
                    setTotalPageCount(response.filterConfig.totalPage);
                }
            }, (error) => {
                setSpinner(false)
                showToast("Error while getting timesheet entries, Please try after sometime.", TOAST_TYPE.FAILURE);
            }
        );
    }

    const formatRowDate = (data,isExpand,needToCollapseDefault) => {
        const rowData = [];
        data.forEach((row,index) => {
            rowData.push({
                ...row,
                dateView: `${row.date} (${row.dateLevelCount})`,
                expanded:needToCollapseDefault ? false : rowExpander[index]?.expand,
                parentIndex:index,
                expandableView:isExpand? getExpandableView(row.employees,'1',index,{row:row,index:index},needToCollapseDefault):false,
                rowData: row
            })
        });

        return rowData;
    }
    const getActionButton=()=>{
        let edit =  {
            // icon: DKIcons.ic_edit,
            title: "Edit",
            className:'p-0 text-app fw-m text-underline',
            onClick: (data) => {
                if (onRowEdit) {
                    onRowEdit(data);
                }
            }
        }
        let options = [edit];
        let actionColumnWidth = 150;
        let actionColumnName = "Actions";
        return {
            key: 'actions',
            name: actionColumnName,
            className:'p-0',
            type: INPUT_TYPE.BUTTON,
            width: actionColumnWidth,
            options
        };
    }
    const getGridContextMenu = () => {
        let options = [];
        let edit = {
            title: "Edit",
            icon: DKIcons.ic_edit,
            onClick: (data) => {
                if (onRowEdit) {
                    onRowEdit(data);
                }
            },
        }
        options= [edit]
        return options
    }
    const onRowSelectChildGrid=(data)=>{
        
        if(data) {
            let tsRowData = timesheetData?.rowData || [];
            tsRowData[data?.rowData?.parentIndex].employees[data?.rowData?.childIndex].timesheetEntries[data?.rowIndex]['selected'] = data?.rowData?.selected
            updateApproveReject(tsRowData);
            setTimesheetData({
                ...timesheetData,
                rowData: formatRowDate(tsRowData,true) || []
            })
        }
    }
    const onAllRowSelect=(data,parentIndex,childIndex)=>{
        
        let tsRowData = timesheetData?.rowData || [];
        tsRowData[parentIndex].employees[childIndex].timesheetEntries?.forEach(d=>{
            d['selected'] = data.selected;
        })
        tsRowData[parentIndex].employees[childIndex]['selected'] = data.selected;
        updateApproveReject(tsRowData);
        setTimesheetData({
            ...timesheetData,
            rowData: formatRowDate(tsRowData,true) || []
        })
        
    }

    const onMiddleRowSelectChildGrid=(data)=>{
        if(data) {
            let tsRowData = timesheetData?.rowData || [];
            tsRowData[data.rowData?.parentIndex].employees[data.rowData?.childIndex]['selected'] = data.rowData?.selected
            tsRowData[data.rowData?.parentIndex].employees[data.rowData?.childIndex].timesheetEntries?.forEach(childData=>{
                childData['selected'] = data.rowData?.selected
            })
            updateApproveReject(tsRowData);
            setTimesheetData({
                ...timesheetData,
                rowData: formatRowDate(tsRowData,true) || []
            })
        }
    }
    const onAllMiddleRowSelect=(data,rowData,parentIndex)=>{
        let tsRowData = timesheetData?.rowData || [];
        tsRowData[parentIndex].employees?.forEach(emp=>{
            emp['selected'] = data.selected
            emp.timesheetEntries.forEach(rep=>{
                rep['selected'] = data.selected
            })
        })
        updateApproveReject(tsRowData);
        setTimesheetData({
            ...timesheetData,
            rowData: formatRowDate(tsRowData,true) || []
        })
        
    }
    
    // level 1
    const getExpandableView = (rowData,step,index,parent,needToCollapseDefault) => {
        if (rowData != null) {
        
            const rowsObj = rowData.map((row,i) => {
                return{
                    ...row,
                    employeeId: `${row.employeeDetails.employeeName} (${row.entriesCount})`,
                    expanded:needToCollapseDefault ? false : rowExpander[index]?.childIndex?.includes(i) ,
                    expandableView:getEmployeeExpandableView(row.timesheetEntries,parent,i),
                    rowData: row,
                    parent:parent.row,
                    parentIndex:parent.index,
                    childIndex:i,
                    selected:row.timesheetEntries.filter(r=>!r.selected).length===0
                }
            })
            
            let columnsObj = parseVisibleColumnConfig(parseColumnConfig(TIMESHEET_REORT_SUB_GRID_COLUMN), TABLES.PEOPLE_TIMESHEET_REPORT);
           
            return (
              <div className="z-index-5" >
                <DKDataGrid
                    allowBulkOperation={true}
                    allowColumnEdit={false}
                    allowColumnDelete={false}
                    allowColumnShift={false}
                    allowSearch={false}
                    allowFilter={false}
                    allowRowEdit={true}
                    allowExpand={true}
                    onRowExpand={(data) => {
                        updateRowExpanded(data, step, index);
                    }}
                    allowDataExport={false}
                    isActionEnabled={false}
                    onRowOpenBtnHidden={true}
                    isHeaderHidden={true}
                    columns={columnsObj}
                    rows={rowsObj}
                    onRowClick={onSubRowClick}
                    needTrailingColumn={true}
                    width={width*.99}
                    onRowSelect={onMiddleRowSelectChildGrid}
                    onAllRowSelect={(data)=>onAllMiddleRowSelect(data,rowsObj,parent.index)}
                    isAllRowSelected={rowsObj.filter(r=>!r.selected).length===0}
                     />
              </div>
            );
        } else {
            return (
                <div
                  className="p-h-xxl bg-gray1 parent-width column align-items-center justify-content-center"
                  style={{ height: 30 }}
                >
                  <DKLabel text="No data available" className="mt-r fs-m" />
                </div>
              );
        }
    }

    const onColumnShift = (data) => {
        let { newIndex, oldIndex } = data;
        
        if(newIndex<0) {
          newIndex = oldIndex
        }
        let newColumnArray = shiftArrayElement(
          [...childColumn],
          oldIndex,
          newIndex
        );
        Table.shiftColumn(
          newColumnArray.map((column) => column?.id),
          TableManger.getTableId(TABLES.PEOPLE_TIMESHEET_REPORT_GROUP_SUB_TABLE)
        ).then((data) => {
            getColumns()
            
        });        
      };
      const getColumns = () => {
        Table.getTable(TableManger.getTableId(TABLES.PEOPLE_TIMESHEET_REPORT_GROUP_SUB_TABLE)).then(
            (data) => {
              TableManger.setTableColumns(data, TABLES.PEOPLE_TIMESHEET_REPORT_GROUP_SUB_TABLE);
              const col = parseVisibleColumnConfig(parseColumnConfig(TableManger.getTableVisibleColumns(TABLES.PEOPLE_TIMESHEET_REPORT_GROUP_SUB_TABLE)), TABLES.PEOPLE_TIMESHEET_REPORT_GROUP_SUB_TABLE)
              setChildColumn(col)
              fetchDependencies()
              getReport({ ...TimesheetService.GROUING_REPORTS_API_CONFIG });
            },
            (err) => { }
          );
    };
    
    // level 2
    const getEmployeeExpandableView = (rowData,parentIndex,childIndex) => {
        if (rowData != null) {
            const functionConfig = getFunctionConfig()
            const rowsObj = rowData.map((row,index) => {
                return{
                    ...row,
                    jobId: row.jobName,
                    projectId: row.projectName,
                    customerId: [row.customer],
                    date: [moment((row.fromDate)).format('YYYY-MM-DD')],
                    fromDate: [moment((row.fromDate)).format('hh:mm A')],
                    toDate: [moment(row.toDate).format('hh:mm A')],
                    status: [row.status],
                    isBillable: row.isBillable ? "Yes" : "No",
                    employeeId: row.employeeName,
                    hours: TimesheetUtils.getTimeInString(row.seconds),
                    ratePerHour: `${FormatCurrencyService.format(row.ratePerHour)}`,
                    amount: `${FormatCurrencyService.format(row.amount)}`,
                    dataObj: row,
                    parentIndex:parentIndex.index,
                    childIndex:childIndex,
                    selected:row.selected,
                    rowContextMenu: TimesheetUtils.getReportContextMenuButton(row,functionConfig)

                }
            })
            // let columnsObj = parseVisibleColumnConfig(parseColumnConfig(TIMESHEET_REORT_GROUP_GRID_COLUMN), TABLES.PEOPLE_TIMESHEET_REPORT);
            return (
              <div className="" style={{marginLeft:40,marginBottom:60}}>
                <DKDataGrid
                    tableName={TABLES.PEOPLE_TIMESHEET_REPORT_GROUP_SUB_TABLE}
                    displayTableName={""}
                    allowBulkOperation={true}
                    allowColumnEdit={false}
                    allowColumnDelete={false}
                    allowColumnShift={false}
                    allowSearch={false}
                    allowFilter={false}
                    allowRowEdit={true}
                    allowExpand={false}
                    allowDataExport={false}
                    isActionEnabled={true}
                    onRowOpenBtnHidden={true}
                    isHeaderHidden={true}
                    columns={[...childColumn,getActionButton()]}
                    rows={rowsObj}
                    onRowClick={onSubRowClick}
                    needTrailingColumn={false}
                    width={width*.99}
                    onRowSelect={onRowSelectChildGrid}
                    onAllRowSelect={(data)=>onAllRowSelect(data,parentIndex.index,childIndex)}
                    contextMenu={false}
                    isAllRowSelected={rowsObj.filter(r=>!r.selected).length===0}
                    onColumnShift={(data)=>{
                        
                        showAlert("Column change detect","Reload grid that reflect column change in each sub grid.",[{
                            title: "Reload Now",
                            className: "bg-app text-white ml-r",
                            onClick: () => {
                                onColumnShift(data)
                            }
                        }])
                    }}
                     />
              </div>
            );
        } else {
            return (
                <div
                  className="p-h-xxl bg-gray1 parent-width column align-items-center justify-content-center"
                  style={{ height: 30 }}
                >
                  <DKLabel text="No data available" className="mt-r fs-m" />
                </div>
              );
        }
    }
    const getFunctionConfig = () =>{
        return {
            "onRowDelete":onRowDelete,
            "onApproveReject":onApproveReject,
            "onSubmit": onSubmit
        }
    }
    
    const onSubRowClick = (rowIndex, rowData) => {
      
    };
    const onRowDelete = (data) => {
        if (data?.rowData) {
            if (data.rowData.status === "APPROVED" || data.rowData.status === "REJECTED") {
                showToast("Not allowed to delete admin approved/rejected timesheet entry.", TOAST_TYPE.WARNING);
                return;
            }

            const payload = {
                ids: [`${data.rowData.id}`]
            };

            showLoader("Deleting timesheet entry... Please wait");
            TimesheetService.deleteTimesheetEntry(payload).then(
                (response) => {
                    removeLoader();
                    showToast("Deleted timesheet entry successfully.", TOAST_TYPE.SUCCESS);
                    getReport({ ...TimesheetService.GROUING_REPORTS_API_CONFIG });
                }, (error) => {
                    removeLoader();
                    if (error?.message) {
                        showToast(error.message, TOAST_TYPE.FAILURE);
                    } else {
                        showToast("Error while deleting timesheet entry, Please try after sometime.", TOAST_TYPE.FAILURE);
                    }
                }
            );
        }
    }

    const onRowEdit = (data) => {
        TimesheetService.REPORT = data?.rowData.dataObj;
        setShowAddTimesheet(true);
    }
    useEffect(()=>{
        if(timesheetData && timesheetData?.rowData ) {
            setTimesheetData({
                ...timesheetData,
                rowData: formatRowDate(timesheetData?.rowData,true) || []
            })
        }
        
    },[rowExpander])

    const updateRowExpanded = (data,a,b,c) => {        
        let newExpander = deepClone(rowExpander)
        if(data && data.rowData && data.rowData.hasOwnProperty('childIndex') ) {
            let isInclude = newExpander[data.rowData.parentIndex].childIndex?.includes(data.rowData.childIndex)
            if(data.rowData.expanded) {
                
                if(!isInclude) {
                    newExpander[data.rowData.parentIndex].childIndex?.push(data.rowData.childIndex)
                }
            } else {
                if(isInclude) {
                    const ind = newExpander[data.rowData.parentIndex].childIndex.indexOf(data.rowData.childIndex);
                    let newChild = newExpander[data.rowData.parentIndex].childIndex.splice(ind, 1)
                }
            }
        } else if(data && data.rowData && data.rowData.hasOwnProperty('parentIndex')) {
            if(data.rowData.expanded) {
                newExpander={
                ...newExpander,
                [data.rowData.parentIndex]:{
                        expand:true,
                        childIndex:[]
                    }
                }
            } else {
                newExpander={
                    ...newExpander,
                    [data.rowData.parentIndex]:{
                        expand:false,
                        childIndex:[]
                    }
                }
            }
        }
        setRowExpander(newExpander)
    }

    const refresh = (data) => { }

    const onSearch = (data) => {
        const config = {
            ...TimesheetService.GROUING_REPORTS_API_CONFIG,
            searchString: data
        }
        getReport(config);
    }

    const onFilter = (updatedList, queries) => {
        
        const oldQuery = deepClone(queries)
        const config = {
            ...TimesheetService.GROUING_REPORTS_API_CONFIG,
            fromDate: fromDate.format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
            toDate: toDate.format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
        }
        if(queries && queries.length === 0) {
            delete config['status']
            delete config['projectId']
            delete config['jobId']
            delete config['customerId']
            delete config['isBillable']
        }
        let columns = childColumn;
        queries.forEach(f => {
            const ind = columns.findIndex(c => c?.id === f.key)
            if (ind !== -1) {
                if (f.key === 'bill') {
                    config['isBillableFilter'] = true;
                    config['isBillableValue'] = f?.value[0]
                } else {
                    config[columns[ind].columnCode] = f?.value[0]
                }

            }
        }
        )
        setFilterArray(oldQuery)
        getReport(config);
    }

    const onRowAdd = (data) => { }

    const onRowSelect = (data) => { }

    const getDatePickerTitle = () => {
        return `${Utility.formatDate(fromDate.format(DATE_FORMAT.IND), DATE_FORMAT.IND)} - ${Utility.formatDate(toDate.format(DATE_FORMAT.IND), DATE_FORMAT.IND)}`;
    }

    const renderDateRangePicker = () => {
        return (
            <div className="position-absolute bg-white z-index-6 rounded border-m" style={{ top: 89, right: 160 }}>
                <DKDateRangePicker
                    className="border shadow "
                    color={'rgb(0, 102, 65)'}
                    startDate={fromDate.toDate()}
                    selectedStartDate={fromDate.toDate()}
                    selectedEndDate={toDate.toDate()}
                    onSelectDateRange={(startDate, endDate) => {
                        if (startDate && endDate) {
                            setFromDate(moment(startDate).startOf("day"));
                            setToDate(moment(endDate).endOf("day"));
                            setShowDateRangePicker(false);
                            setCurrentPage(1);
                            const config = {
                                ...TimesheetService.GROUING_REPORTS_API_CONFIG,
                                fromDate: moment(startDate).startOf("day").format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
                                toDate: moment(endDate).endOf("day").format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
                            };
                            TimesheetService.GROUING_REPORTS_API_CONFIG = { ...config }
                            getReport(config);
                        }
                    }}
                    onClose={() => {
                        setShowDateRangePicker(false);
                    }}
                />
            </div>
        );
    }
    const onApproveReject = (data,isApprove)=>{
        
        if(data?.rowData) {
            const payload = {
                status: isApprove ? TIMESHEET_CONSTANTS.APPROVED:TIMESHEET_CONSTANTS.REJECTED,
                ids : [data?.rowData?.id]
            }
            TimesheetService.updateTimesheetStatus(payload).then(() => {
                showToast("Timesheets updated", TOAST_TYPE.SUCCESS);
                const config = {
                    ...TimesheetService.GROUING_REPORTS_API_CONFIG,
                }
                getReport(config,true);
            })
        }
    }
    const onSubmit=(data)=>{
        let payload
        
        if (data?.rowData) {
            if (data.rowData.status === "APPROVED" ) {
                showAlert("Info","Not allowed to submit admin approved timesheet entry.");
                return;
            }
            if( Utility.isEmpty(data.rowData?.toDate)) {
                showToast("Please stop timer to submit draft Timesheet entry")
                return
            }
            payload = {
                ids: [`${data.rowData.id}`]
            };

            TimesheetService.submitTimesheetEntry(payload).then(() => {
                showToast("Timesheets Submitted", TOAST_TYPE.SUCCESS);
                
                const config = {
                    ...TimesheetService.GROUING_REPORTS_API_CONFIG,
                }
                getReport(config);
            })  
        } else {
            data = selectedRecords;
            
                let isAllow = true;
                let isApprovedRejected = true
                let ids = []
                data.forEach(d => {
                    if (d.status === "APPROVED" ) {
                        isApprovedRejected = false
                    }
                    if ( Utility.isEmpty(d?.toDate)) {
                        showToast("Please stop timer to delete draft Timesheet entry")
                        isAllow = false
                    }
                    ids.push(d?.id)
                })

                if(!isAllow || !isApprovedRejected) {
                    
                    const config = {
                        ...TimesheetService.GROUING_REPORTS_API_CONFIG,
                    }
                    getReport(config);
                    if(!isApprovedRejected) {
                        showAlert("Info","Timesheet which already Approved not allow to submit.")
                    }
                    return
                }
                const payload = {
                    ids : ids
                }
                TimesheetService.submitTimesheetEntry(payload).then(() => {
                showToast("Timesheets Submitted", TOAST_TYPE.SUCCESS);
                    const config = {
                        ...TimesheetService.GROUING_REPORTS_API_CONFIG,
                        fromDate: fromDate.format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
                        toDate: toDate.format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
                    }
                    getReport(config);
                })                           
            
        }
    }
    const toggleFilterPopup = () => {
        setFilterPopupState(!filterPopupState)
    };
    const getFilterPopup = () => {
        return (
            <div className="filter">
                <DKFilterPopup
                    filterData={[...filterArray]}
                    headers={getUpdatedFilterableColumns()}
                    onSubmit={(data) => {
                        toggleFilterPopup();
                        onFilter(null, data);
                    }}
                    onCancel={() => toggleFilterPopup()}
                />
            </div>
        );
    }
    const getUpdatedFilterableColumns = () => {
        return (
            childColumn?.filter((obj) => {
                    return (
                        obj.type &&
                        obj.type !== INPUT_TYPE.BUTTON &&
                        obj.type !== INPUT_TYPE.MORE &&
                        (obj.allowFilter ?? true)
                    );
                })
                .map((obj) => {
                    return obj;
                }) || []
        );
    };
    const updateApproveReject = (rowData) =>{
        let approveReject = {
            isApproveEnable:false,
            isRejectEnable:false
        }
        let totalSelectedRecords = [];
        rowData.forEach(row=>{
            row.employees.forEach(emp=>{
                totalSelectedRecords = [...totalSelectedRecords, ...emp.timesheetEntries.filter(rep=>rep.selected)]
            })
        })
        //Note:use leter const isApproveRejected = totalSelectedRecords.filter(rec => rec.status === TIMESHEET_CONSTANTS.APPROVED || rec.status === TIMESHEET_CONSTANTS.REJECTED).length === 0
        let records = totalSelectedRecords//Note:use leter totalSelectedRecords.filter(rec=> rec.status === TIMESHEET_CONSTANTS.SUBMITTED)
        
        approveReject = {
            isApproveEnable: totalSelectedRecords.length >0 ,
            isRejectEnable: totalSelectedRecords.length >0  
        }
        setSelectedRecords(records)
        setApproveReject(approveReject)
    }
    
    const getHeader=()=>{
        return (
            <div className="row justify-content-between">
                <div className="row">
                <DKLabel className="fw-m fs-m" text={TABLE_DISPLAY_NAME[TABLES.PEOPLE_TIMESHEET_REPORT_GROUP]}/>
                {showSpinner && <DKSpinner className="ml-s"/>}
                {
                    (approveReject?.isApproveEnable && PermissionUtils.hasAccess(MODULE.TIMESHEET, [ACTION.APPROVE])) && <DKButton onClick={()=>approveRejectAction(true)} className="bg-app text-white ml-m mr-s" title={i18next.t(TIMESHEET_CONSTANTS.APPROVE)}/>
                }
                {
                    (approveReject?.isRejectEnable && PermissionUtils.hasAccess(MODULE.TIMESHEET, [ACTION.REJECT])) && <DKButton onClick={()=>approveRejectAction(false)} className="text-white bg-red border-m mr-r" title={i18next.t(TIMESHEET_CONSTANTS.REJECT)}/>
                }
                
                </div>
                <div className="d-flex">
                    
                    <DKSearchBar
                        searchText={TimesheetService.GROUING_REPORTS_API_CONFIG?.searchString}
                        onSearch={onSearch}
                    />
                    { <div className="row width-auto position-relative kanban-filter-container pr-s">
                            <DKIcon
                                src={DKIcons.ic_filter}
                                className="ic-s bg-white p-s border-m border-radius-m cursor-hand"
                                onClick={() => toggleFilterPopup()}
                            />
                            {filterArray?.length ? (
                                <div
                                    className="position-absolute bg-red circle"
                                    style={{
                                        width: 5,
                                        height: 5,
                                        top: 0,
                                        left: 30,
                                    }}
                                ></div>
                            ) : null}
                            {filterPopupState && getFilterPopup()}
                        </div>}
                    <DKButton title={getDatePickerTitle()} icon={DKIcons.ic_calendar} className="bg-white border-m mr-s"
                    onClick={ () => {
                        setShowDateRangePicker(true)
                    }}/>
                    <DKButton title={`+ ${"Timesheet Entry"}`} className="bg-app text-white "
                    onClick={ () => {
                        setShowAddTimesheet(true);
                    }}/>
                    
                </div>
            </div>
        )
    }
    const approveRejectAction=(isApprove)=>{
        let data = selectedRecords
        const payload = {
            status: isApprove? TIMESHEET_CONSTANTS.APPROVED:TIMESHEET_CONSTANTS.REJECTED,
            ids: data.map(data => data.id)
        }
        
        TimesheetService.updateTimesheetStatus(payload).then(() => {
            setSelectedRecords([])
            setTimesheetData({
                ...timesheetData,
                rowData:[]
            })
            showToast(`Timesheet has been successfully ${isApprove? TIMESHEET_CONSTANTS.APPROVE?.toLocaleLowerCase():TIMESHEET_CONSTANTS.REJECT?.toLocaleLowerCase()}`, TOAST_TYPE.SUCCESS);
            const config = {
                ...TimesheetService.GROUING_REPORTS_API_CONFIG,
            }
            getReport(config,true);
        })
    }
    const addMenuButton = () => {
        let menuBtn = []
        const approveBtn = {
            title: i18next.t(TIMESHEET_CONSTANTS.APPROVE),
            className: "bg-app text-white mr-s ",
            hide: false,
            onClick: (data, value) => {
                const payload = {
                    status: TIMESHEET_CONSTANTS.APPROVED,
                    ids: data.map(data => data.id)
                }
                TimesheetService.updateTimesheetStatus(payload).then(() => {
                    showToast("Timesheets approved", TOAST_TYPE.SUCCESS);
                    const config = {
                        ...TimesheetService.GROUING_REPORTS_API_CONFIG,
                    }
                    getReport(config);
                })
            },
        };
        const rejectBtn = {
            title: i18next.t(TIMESHEET_CONSTANTS.REJECT),
            className: "text-white bg-red border-m mr-r ",
            hide: false,
            onClick: (data, value) => {
                const payload = {
                    status: TIMESHEET_CONSTANTS.REJECTED,
                    ids: data.map(data => data.id)
                }
                TimesheetService.updateTimesheetStatus(payload).then(() => {
                    showToast("Timesheets rejected", TOAST_TYPE.SUCCESS);
                    const config = {
                        ...TimesheetService.GROUING_REPORTS_API_CONFIG,
                    }
                    getReport(config);
                })
            },
        }
            
        const submitBtn = {
            title: t("Submit"),
            className: "bg-blue text-white mr-s ",
            hide: true,                        
            onClick: (data, value) => {  
                let isAllow = true;
                let isApprovedRejected = true
                let ids = []
                data.forEach(d => {
                    if (d.status === "APPROVED" ) {
                        isApprovedRejected = false
                    }
                    if ( Utility.isEmpty(d?.toDate)) {
                        showToast("Please stop timer to delete draft Timesheet entry")
                        isAllow = false
                    }
                    ids.push(d?.id)
                })

                if(!isAllow || !isApprovedRejected) {
                    
                    const config = {
                        ...TimesheetService.GROUING_REPORTS_API_CONFIG,
                    }
                    getReport(config);
                    if(!isApprovedRejected) {
                        showAlert("Info","Timesheet which already Approved not allow to submit.")
                    }
                    return
                }
                const payload = {
                    ids : ids
                }
                TimesheetService.submitTimesheetEntry(payload).then(() => {
                showToast("Timesheets Submitted", TOAST_TYPE.SUCCESS);
                    const config = {
                        ...TimesheetService.GROUING_REPORTS_API_CONFIG,
                    }
                    getReport(config);
                })                           
            },
        };
            

        const createInvoiceBtn = {
                title: i18next.t("Create Invoice"),
                className: "bg-app text-white mr-s",
                hide: true,
                condition: {
                    columnCode: "status",
                    value: "APPROVED",
                },
                onClick: (data, value) => {
                    const payload = {
                        timesheetIds: data.map(data => data.id)
                    }
                    TimesheetService.createInvoice(payload).then(
                        (response) => {
                            showToast(
                                "Invoice created successfully",
                                TOAST_TYPE.SUCCESS
                            );
                        }, (error) => {
                            showToast(error?.error, TOAST_TYPE.FAILURE);
                        }
                    );
                },
        }
        if(PermissionUtils.hasAccess(MODULE.TIMESHEET, [ACTION.APPROVE])) {
            menuBtn.push(approveBtn)
        }
        if(PermissionUtils.hasAccess(MODULE.TIMESHEET, [ACTION.REJECT])) {
            menuBtn.push(rejectBtn)
        }
        if(PermissionUtils.hasAccess(MODULE.TIMESHEET, [ACTION.SUBMIT])) {
            menuBtn.push(submitBtn)
        }
        if(PermissionUtils.hasAccess(MODULE.TIMESHEET, [ACTION.CREATE,ACTION.EDIT, ACTION.SUBMIT, ACTION.APPROVE, ACTION.REJECT])) {
            menuBtn.push(createInvoiceBtn)
        }
        return menuBtn
    }
    // main level
    return (
        <>
            {showAddTimesheet &&
                <AddTimesheetReport
                    onClose={(refresh) => {
                        setShowAddTimesheet(false);
                        if (refresh) {
                            getReport({ ...TimesheetService.GROUING_REPORTS_API_CONFIG });
                        }
                    }}
                />
            }
            {showDateRangePicker && renderDateRangePicker()}
            {filterCustomerPopup.show && (
                  <DKListPicker2
                    data={[{id:'all',name:'All'},...customer]}
                    className="position-absolute border-m shadow-m "
                    style={{ top: 80, right: 590, zIndex: 99999 }}
                    renderer={(index, c) => {
                        return (c.name);
                    }}
                    
                    onSelect={(index, value) => {
                         let config= {
                            ...TimesheetService.GROUING_REPORTS_API_CONFIG, 
                        }
                        if(value.id !=='all') {
                            config['customerId']= value.id 
                        } else {
                            delete config['customerId']
                        }
                        TimesheetService.GROUING_REPORTS_API_CONFIG = {...config}
                        getReport(config);
                    

                    setFilterCustomerPopup({
                        ...filterCustomerPopup,
                        value:value.name,
                        show:false
                    })

                    }}
                    onClose={(e) => setFilterCustomerPopup({...filterCustomerPopup,show:false})}
                  />
                )}
                <div className="column parent-width flex-1 ">
                <div className="column parent-width mb-s position-relative flex-1 ">
            <DKButton
                icon={ic_arrow_back}
                title={t("BACK")}
                className="pl-0 p-v-0 pr-0 cursor-hand fw-b mb-s"
                onClick={() => {
                    RouteManager.navigateToPage(PAGE_ROUTES.TIMESHEET_REPORT_LIST);
                }}
            />
            {getHeader()}
            <DataGridHolderPayroll
            tableName={TABLES.PEOPLE_TIMESHEET_REPORT_GROUP}
            displayTableName={"Timesheet report grid"}
                allowColumnEdit={false}
                allowColumnDelete={false}
                allowColumnShift={false}
                allowSearch={false}
                allowFilter={false}
                allowExpand={true}
                allowRowEdit={false}
                isMenuVisible={true}
                showContextMenu={true}
                showContextEdit={false}
                onRowDelete={onRowDelete}
                onRowEdit={(data) => {
                    onRowEdit(data);
                }}
                onRowExpand={(data) => {
                    updateRowExpanded(data,'0',-1);
                }}
                refresh={refresh}
                allowRowAdd={true}
                addMenuButton={addMenuButton()}
                onApproveReject={onApproveReject}
                allowDataExport={false}
                gridData={timesheetData}
                onSearch={onSearch}
                onFilter={onFilter}
                filter={filterArray}
                onRowAdd={onRowAdd}
                onPaginationClick={(requestedPageNumber) => {
                    const config = {
                        ...TimesheetService.GROUING_REPORTS_API_CONFIG,
                        currentPage: requestedPageNumber,
                    };
                    getReport(config);
                }}
                currentPage={currentPage}
                totalPageCount={totalPageCount}
                isActionEnabled={false}
                contextMenu={false}
                onSelection={onRowSelect}
                allowColumnSort={false}
                allowBulkOperation={false}
                isHeaderHidden={true}
            />
            </div>
            </div>
        </>
    );
}

export default TimesheetReportGrouping;
